import axios from 'axios'

export default {
  namespaced: true,
  state: {
    config: sessionStorage.getItem('config') ? JSON.parse(sessionStorage.getItem('config')) : false
  },
  mutations: {
    getConfig  (state, config) {
      state.config = config
      sessionStorage.setItem('config', JSON.stringify(config))
    }
  },
  actions: {
    getConfig ({commit}) {
      if (sessionStorage.getItem('config')) {
        return false
      }
      axios('/common/schema/config').then((response) => {
        commit('getConfig', response.data.properties.ceramic.default)
      })
    }
  },
  getters: {
    config: (state) => {
      return state.config || []
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ConfigStore.js